import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PagingTable from '../common/pagingTable/pagingTable';
import cabinetActionCreators from '../../actions/cabinetActionCreators';
const cabinetPagingTable = () => {
  /**
   *  Map the subcabinet (state.cabinet[currentCabinet]) properties for paging
   */
  const mapStateToProps = state => {
    if (state.cabinet && state.cabinet.currentCabinet && state.cabinet[state.cabinet.currentCabinet]) {
      const cab = state.cabinet[state.cabinet.currentCabinet];
      const _cab$hasNext = cab.hasNext,
        hasNext = _cab$hasNext === void 0 ? false : _cab$hasNext,
        _cab$hasPrevious = cab.hasPrevious,
        hasPrevious = _cab$hasPrevious === void 0 ? false : _cab$hasPrevious,
        _cab$indexQuery = cab.indexQuery,
        indexQuery = _cab$indexQuery === void 0 ? {
          paging: {
            current: 0
          }
        } : _cab$indexQuery;
      return {
        hasNext,
        hasPrevious,
        indexQuery
      };
    }
    return {
      hasNext: false,
      hasPrevious: false,
      indexQuery: {
        paging: {
          current: 0
        }
      }
    };
  };
  const mapDispatchToProps = dispatch => {
    const actions = bindActionCreators(cabinetActionCreators, dispatch);
    return {
      handlePreviousPage: actions.pagePrevious,
      handleNextPage: actions.pageNext,
      sortBy: actions.sortBy
    };
  };
  return connect(mapStateToProps, mapDispatchToProps)(PagingTable);
};
export default cabinetPagingTable();